import { UIElement, UIElementTypes } from '../element';
import RectangleUiListElement from './RectangleUiListElement.svelte';
import '../../types';
import { createBangleJSUiCode } from './bangleCode';
import { isPointInRectangle } from '../../utils/helpers';
import { elementSelectionStore } from '../../stores/elementsSelection';
import { SCREEN_HEIGHT, SCREEN_WIDTH } from '../../constants';
export class UIRectangle extends UIElement {
    constructor(args) {
        super(UIElementTypes.RECT, args.x, args.y, args.z, args.name, args.id);
        this.width = args.width;
        this.height = args.height;
        this.color = args.color;
        this.group = args.group;
    }
    convertToCode() {
        return createBangleJSUiCode(this.x, this.y, this.z, this.getRenderBox(), this.name, this.width, this.height, this.color);
    }
    shouldScaleBeAdjusted(capturedEvent, eventValue) {
        return ['drag', 'rotate'].indexOf(eventValue.action) == -1 && capturedEvent !== 'moving';
    }
    convertToUiElement(mountPoint, uiElement, origin) {
        return new RectangleUiListElement({ target: mountPoint, props: { uiElement, origin } });
    }
    renderElement(ctx, originCords) {
        const selected = elementSelectionStore.isSelected(this);
        const x = this.x + originCords.x;
        const y = this.y + originCords.y;
        const path = new Path2D();
        path.moveTo(x, y);
        path.lineTo(x + this.width, y);
        path.lineTo(x + this.width, y + this.height);
        path.lineTo(x, y + this.height);
        path.lineTo(x, y + this.height);
        path.closePath();
        if (selected) {
            ctx.fillStyle = 'green';
        }
        else {
            ctx.fillStyle = this.color;
        }
        ctx.fill(path, 'evenodd');
    }
    isSelected(pointerX, pointerY) {
        return isPointInRectangle(pointerX, pointerY, { x: this.x, y: this.y }, {
            x: this.x + this.width,
            y: this.y + this.height
        });
    }
    moveElement(deltaX, deltaY) {
        this.x += deltaX;
        this.y += deltaY;
    }
    get isOutsideOfScreenArea() {
        return this.x + this.width <= 0 || this.x >= SCREEN_WIDTH || this.y + this.height <= 0 || this.y >= SCREEN_HEIGHT;
    }
    getRenderBox() {
        return {
            tl: { x: this.x, y: this.y },
            br: { x: this.x + this.width, y: this.y + this.height }
        };
    }
}
